import { createIconInner } from '##/icons/Icon/createIconInner';

import props from './props';
import svg from './svg';

export const IconHorizonFolderGreen = createIconInner(props, svg);
